// 应用配置
export const APP_CONFIG = {
  name: process.env.REACT_APP_NAME || 'DeFi',
  version: process.env.REACT_APP_VERSION || '1.0.0',
  env: process.env.REACT_APP_ENV || 'production'
};

// 网络配置
export const NETWORK_CONFIG = {
  network: 'ethereum',
  chainId: 1,
  rpcUrl: process.env.REACT_APP_ETHEREUM_URL || 'https://mainnet.infura.io/v3/72572d06070d4d65b9542131827f1ec6',
  explorerUrl: 'https://etherscan.io'
};

// 以太坊主网配置
export const ETHEREUM_CONFIG = {
  rpcUrl: process.env.REACT_APP_ETHEREUM_URL || 'https://mainnet.infura.io/v3/3b41acf3fb514355ad7143e56d89ae8a',
  rpcUrl2: process.env.REACT_APP_ETHEREUM_URL_2 || 'https://mainnet.infura.io/v3/72572d06070d4d65b9542131827f1ec6',
  rpcUrl3: process.env.REACT_APP_ETHEREUM_URL_3 || 'https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161'
};

// 合约地址配置
export const CONTRACT_ADDRESSES = {
  weth: process.env.REACT_APP_WETH_ADDRESS || '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', // 主网 WETH 地址
  usdc: process.env.REACT_APP_USDC_ADDRESS || '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', // 主网 USDC 地址
  exchange: process.env.REACT_APP_EXCHANGE_ADDRESS || 'YOUR_MAINNET_EXCHANGE_ADDRESS',
  lendingPool: process.env.REACT_APP_LENDING_POOL_ADDRESS || 'YOUR_MAINNET_LENDING_POOL_ADDRESS',
  miningPool: process.env.REACT_APP_MINING_POOL_ADDRESS || 'YOUR_MAINNET_MINING_POOL_ADDRESS'
};

export const EXCHANGE_ADDRESS = CONTRACT_ADDRESSES.exchange;

// API配置
export const API_CONFIG = {
  coingecko: process.env.REACT_APP_COINGECKO_API_URL || 'https://api.coingecko.com/api/v3',
  etherscan: process.env.REACT_APP_ETHERSCAN_API_KEY || ''
};

// WalletConnect配置
export const WALLET_CONNECT_CONFIG = {
  projectId: process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID || ''
};

// 部署配置
export const DEPLOY_CONFIG = {
  deployerPrivateKey: process.env.REACT_APP_DEPLOYER_PRIVATE_KEY || '',
  testAccountPrivateKey: process.env.REACT_APP_TEST_ACCOUNT_PRIVATE_KEY || ''
};

// 测试配置
export const TEST_CONFIG = {
  testWalletPrivateKey: process.env.REACT_APP_TEST_WALLET_PRIVATE_KEY || '',
  testWalletAddress: process.env.REACT_APP_TEST_WALLET_ADDRESS || ''
};

// 交易配置
export const TRANSACTION_CONFIG = {
  defaultSlippage: Number(process.env.REACT_APP_DEFAULT_SLIPPAGE) || 0.5,
  maxSlippage: Number(process.env.REACT_APP_MAX_SLIPPAGE) || 5,
  minSlippage: Number(process.env.REACT_APP_MIN_SLIPPAGE) || 0.1,
  gasLimit: Number(process.env.REACT_APP_GAS_LIMIT) || 300000,
  confirmationBlocks: Number(process.env.REACT_APP_CONFIRMATION_BLOCKS) || 1
};

// 多链配置
export const SUPPORTED_CHAINS = (process.env.REACT_APP_SUPPORTED_CHAINS || '1').split(',').map(Number);

// 链配置
export const CHAIN_CONFIGS = (() => {
  try {
    return JSON.parse(process.env.REACT_APP_CHAIN_CONFIGS || '{}');
  } catch (error) {
    console.error('Failed to parse chain configs:', error);
    return {};
  }
})();

// 创建默认导出对象
const defaultConfig = {
  APP_CONFIG,
  NETWORK_CONFIG,
  ETHEREUM_CONFIG,
  CONTRACT_ADDRESSES,
  API_CONFIG,
  WALLET_CONNECT_CONFIG,
  DEPLOY_CONFIG,
  TEST_CONFIG,
  TRANSACTION_CONFIG,
  SUPPORTED_CHAINS,
  CHAIN_CONFIGS
};

// 导出默认配置
export default defaultConfig; 